import styled from 'styled-components'
import ReactPlayer from 'react-player'

import settingsIcon from '../../../assets/conferencesScreen/settings.svg'
import cameraIcon from '../../../assets/conferencesScreen/camera.svg'
import microphoneIcon from '../../../assets/conferencesScreen/microphone.svg'

import muteIcon from '../../../assets/conferencesScreen/mutedIcon.svg'
import speakingIcon from '../../../assets/conferencesScreen/speakingicon.svg'
import cameraOffIcon from '../../../assets/conferencesScreen/cameraOffIcon.svg'

import MuteSelfIcon from '../../../assets/REDESIGN_Assets/Conferences/mute-icon.svg'
import TurnOffSelfCamera from '../../../assets/REDESIGN_Assets/Conferences/turn-off-camera.svg'

export const ConferencesScreenContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  font-family: 'Asap Condensed';
  width: 100%;
  box-sizing: border-box;
  scroll-behavior: smooth;

  &.flex-row {
    flex-direction: row;
  }

  &.flex-column {
    flex-direction: column;
  }
`

export const ConferenceRoomContainer = styled.div`
  padding: 0 3.1vw;
  box-sizing: border-box;
  display: flex;
`

export const TestRoomButton = styled.button`
  width: 20%;
  height: 50px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 10px;
`

export const TestQueueBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
`

export const RoomTile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  color: red;
  font-weight: bold;
  font-size: 1.4rem;
  align-self: center;
  margin: 5px 0;
  padding: 5px 0;
`

export const JoinToQueue = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 5px 15px;
  background-color: rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 10px;
`

export const RoomQueueBoxContainer = styled.div`
  display: flex;
  width: 90%;
  align-self: center;
  flex-direction: column;
  padding: 50px 15px;
  box-sizing: border-box;
  margin: 10px;
  border: 1px solid rgba(0, 0, 0, 0.9);
  border-radius: 12px;
  box-shadow: 0 0.8px 1.2px rgba(0, 0, 0, 0.011),
    0 2px 2.9px rgba(0, 0, 0, 0.016), 0 3.8px 5.4px rgba(0, 0, 0, 0.02),
    0 6.7px 9.6px rgba(0, 0, 0, 0.024), 0 12.5px 18px rgba(0, 0, 0, 0.029),
    0 30px 43px rgba(0, 0, 0, 0.04);
  background-color: rgba(0, 0, 0, 0.8);
`

export const QueueHeader = styled.h1`
  color: #fe0d9f;
  text-align: center;
  font-size: 2rem;
  padding: 15px 0;
  font-weight: bold;
`

export const QueuedUsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const QueuedUser = styled.div`
  width: 60%;
  text-align: center;
  margin: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 3px 0;
  color: grey;
  font-weight: normal;
  font-size: 1.1rem;
`

export const QuededUserheader = styled.h2`
  color: blue;
  font-size: 1.3rem;
  text-align: center;
`
export const SessionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  box-sizing: border-box;
  margin: 10px 0;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.09);
  width: 95%;
  margin: 15px auto;
`

export const SessionHeader = styled.h1`
  width: 100%;
  text-align: center;
  margin: 10px 0;
  font-size: 1.5rem;
  color: red;
`

export const MiazgaVideoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* height: 26.3vw; */
  /* margin: 20px auto; */
  position: relative;
`

export const MiazgaMasterVideo = styled(ReactPlayer)`
  width: 100% !important;
  height: auto !important;
`

export const UsersStreamsContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
`
export const VideoTileContainer = styled.div`
  max-width: 50%;
  max-height: 8vw;
  /* height: 500px; */
  /* margin: 10px; */
  width: 50%;
  height: 13.5vw;
  box-sizing: border-box;
  ${'' /* display: none; */}
  position:relative;
  opacity: 0;

  :has(.user-name[id]) {
    opacity: 1;
  }

  [id] {
    opacity: 1;
  }

  &.visible,
  &.user-stream,
  &.camera-off-user,
  &.camera-off-tile {
    display: block;
    opacity: 1;
  }

  &.user-stream {
    border: 2px solid #a1ff68;
  }
`

export const RemoteTilesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const UserTileContainer = styled.div`
  width: 100%;

  margin: 20px 10px;
  box-sizing: border-box;
`

export const UserTileVideoContainer = styled.div`
  width: 20%;
  height: 100%;
`

export const TileVideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const JoinRoomButton = styled.button`
  position: absolute;
  top: 50px;

  opacity: 0.3;

  &.active {
    opacity: 1;
  }
`

export const SettingContainer = styled.div`
  width: 100%;
  padding: 2vh 3%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 2.2px 5.2px -8px rgba(0, 0, 0, 0.012),
    0 5.4px 8.9px -8px rgba(0, 0, 0, 0.018),
    0 10.1px 11.6px -8px rgba(0, 0, 0, 0.022),
    0 18.1px 14.6px -8px rgba(0, 0, 0, 0.026),
    0 33.8px 21.8px -8px rgba(0, 0, 0, 0.028),
    0 81px 80px -8px rgba(0, 0, 0, 0.03);
`

export const SettingsButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const SettingButton = styled.button`
  width: 2.25vw;
  height: 2.25vw;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  /* margin-left: 2.81vw; */
  border: none;
  cursor: pointer;

  &.camera {
    background-image: url(${TurnOffSelfCamera});
  }

  &.microphone {
    background-image: url(${MuteSelfIcon});
  }

  &.settings {
    background-image: url(${settingsIcon});
  }

  &.camera-off {
    opacity: 0.3;
  }

  &.microphone-off {
    opacity: 0.3;
  }
`

export const StartTrainingBadge = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  /* padding: 20px; */

  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const VideosViewContainer = styled.div`
  width: 50%;
  border-right: 1px solid #fe0d9f;
  box-sizing: border-box;
  margin-top: 3%;
`

export const QueueViewContainer = styled.div`
  width: 50%;
  box-sizing: border-box;
  /* margin-top: 3%; */
  padding: 3%;
`

export const ConferenceMainHeader = styled.div`
  width: 50%;
  left: 5%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Asap;
  font-size: 1.8rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.16;
  letter-spacing: normal;
  text-align: left;
  color: #fe0d9f;
  margin: 1% 0 0% 0;
`

export const ConferenceSubHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-family: Asap;
  font-size: 1.3rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.18;
  letter-spacing: normal;
  text-align: left;
  color: #9e0dfe;
  margin: 5% 0 2% 0;
`

export const ChooseFolderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

export const FoldersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 3%;
  box-sizing: border-box;
`

export const MiazgaFolder = styled.div`
  width: 25vw;
  height: 10vw;
  min-width: 200px;
  border: 1px solid #ffe6f5;
  border-radius: 6px;
  box-shadow: 0 1px 1.4px rgba(0, 0, 0, 0.006),
    0 2.5px 3.5px rgba(0, 0, 0, 0.008), 0 4.6px 6.5px rgba(0, 0, 0, 0.01),
    0 8.3px 11.6px rgba(0, 0, 0, 0.012), 0 15.5px 21.7px rgba(0, 0, 0, 0.014),
    0 37px 52px rgba(0, 0, 0, 0.02);
  margin: 10px;
  border-radius: 8px;
  opacity: 0.5;
  filter: blur(4px);
  cursor: not-allowed;

  &.unlocked {
    opacity: 1;
    filter: blur(0px);
    transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    cursor: pointer;

    &:hover {
      transform: scale(1.08);
      box-shadow: 0 1px 1.4px rgba(0, 0, 0, 0.02),
        0 2.5px 3.5px rgba(0, 0, 0, 0.028), 0 4.6px 6.5px rgba(0, 0, 0, 0.035),
        0 8.3px 11.6px rgba(0, 0, 0, 0.042), 0 15.5px 21.7px rgba(0, 0, 0, 0.05),
        0 37px 52px rgba(0, 0, 0, 0.07);
    }
  }
`

export const MiazgaFolderImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 5%;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  border-radius: 8px;
`
export const MiazgaFolderName = styled.span`
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 1.67rem;
`
export const VideoTilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 5%;
`

export const VideoTileBox = styled.div`
  width: 100%;
  margin: 2% 0;
  box-sizing: border-box;
  border: 1px solid #ffe6f5;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
  position: relative;

  &.alt {
    border: 1px solid rgba(255, 255, 255, 0.7);

    &:hover {
      transform: none;
      box-shadow: none;
    }
  }

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 1px 1.4px rgba(0, 0, 0, 0.02),
      0 2.5px 3.5px rgba(0, 0, 0, 0.028), 0 4.6px 6.5px rgba(0, 0, 0, 0.035),
      0 8.3px 11.6px rgba(0, 0, 0, 0.042), 0 15.5px 21.7px rgba(0, 0, 0, 0.05),
      0 37px 52px rgba(0, 0, 0, 0.07);
  }
`

export const VideoTileImage = styled.div`
  width: 20vw;
  height: 10vw;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
`
export const VideoTileInformationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 2%;
`

export const VideoTileName = styled.div`
  font-family: 'Asap';
  font-size: 1.2rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: left;
  color: #fe0d9f;

  &.alt {
    color: white;
  }
`

export const VideoTileTime = styled.div`
  font-family: 'Asap';
  font-size: 1rem;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  text-align: left;
  color: #212121;

  &.alt {
    color: rgba(255, 255, 255, 0.6);
  }
`

export const RoomTileBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-top: 20px;
  border-radius: 30px;
  /* border: 1px solid #ffe6f5; */
  padding: 5%;
  flex-wrap: wrap;
  display: flex;
  margin-bottom: 3%;
  background: rgba(255, 255, 255, 0.25);

  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 1px 1.4px rgba(0, 0, 0, 0.02),
      0 2.5px 3.5px rgba(0, 0, 0, 0.028), 0 4.6px 6.5px rgba(0, 0, 0, 0.035),
      0 8.3px 11.6px rgba(0, 0, 0, 0.042), 0 15.5px 21.7px rgba(0, 0, 0, 0.05),
      0 37px 52px rgba(0, 0, 0, 0.07);
    /* border: 1px solid transparent; */
  }
`
export const RoomRow = styled.div`
  display: flex;
  width: ${(props) => (props.width ? props.width : '100%')};
  justify-content: ${(props) => (props.justify ? props.justify : 'unset')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'unset')};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  position: relative;
`

export const RoomHeader = styled.span`
  font-family: 'Asap';
  font-size: 1.1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: left;
  color: #fe0d9f;
`

export const RoomLightText = styled.span`
  font-family: 'Asap';
  font-size: 0.9rem;
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #212121;

  &.aligned {
    margin-bottom: 20px;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 0.7rem;
  }
`
export const RoomBoldText = styled.span`
  font-family: 'Asap';
  font-size: 1.1rem;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
  margin-top: 2px;
  margin-left: 4%;

  &.alt {
    margin-left: 0%;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 0.8rem;
  }
  @media only screen and (max-width: 1024px) {
  }
`

export const RoomUsersText = styled.span`
  font-family: 'Asap';
  font-size: 0.6rem;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: center;
  color: #212121;

  @media only screen and (max-width: 1024px) {
  }
  @media only screen and (max-width: 1024px) {
  }
`

export const RoomJoinButton = styled.button`
  width: 80%;
  background: #a1ff68;

  font-family: 'Nunito';
  font-size: 0.65rem;
  letter-spacing: -0.28px;
  color: #601c6a;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  border-radius: 19px;
  /* letter-spacing: 1.3px; */
  text-align: center;
  /* color: #fff; */
  border: none;
  text-transform: uppercase;
  position: absolute;
  box-sizing: border-box;
  padding: 3% 5%;
  opacity: 0.3;

  &.active {
    opacity: 1;
  }
`

export const LeaveRoomBackBanner = styled.div`
  width: 90%;
  box-sizing: border-box;
  padding: 40px;
  color: azure;
  position: fixed;
  top: ${(props) => (props.top ? props.top : '20vh')};
  left: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 2.8em;
  border-radius: 8px;
  ${'' /* border: 1px solid #ffe6f5; */}
  background: rgba( 0,0,0,0.95 );
  box-shadow: 0 1px 0.9px rgba(0, 0, 0, 0.011),
    0 2.5px 2.1px rgba(0, 0, 0, 0.016), 0 4.6px 4px rgba(0, 0, 0, 0.02),
    0 8.3px 7.1px rgba(0, 0, 0, 0.024), 0 15.5px 13.4px rgba(0, 0, 0, 0.029),
    0 37px 32px rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  z-index: 3;
`

export const BannerButton = styled.button`
  -webkit-align-self: center;
  margin: 10px;
  -ms-flex-item-align: center;
  align-self: center;
  padding: 5px 15px;
  border: none;
  outline: none;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    rgba(254, 13, 160, 1) 0%,
    rgba(250, 174, 1, 1) 100%
  );
  font-family: 'Asap Condensed';
  text-align: center;
  font-weight: 600;
  color: white;
  -webkit-transition: ease-in-out 0.35s all;
  transition: ease-in-out 0.35s all;

  &.padding-big {
    padding: 10px 30px;
  }

  &.bug-button {
    width: 200px;
    background: black;
    color: white;
    position: absolute;
    right: calc(50% - 100px);
    top: 5px;
    padding: 10px 30px;
    box-sizing: border-box;

    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
      0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
      0 100px 80px rgba(0, 0, 0, 0.07);
  }
`

export const MutedIndicator = styled.div`
  width: 22px;
  height: 22px;
  background-image: url(${speakingIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 2;
  cursor: pointer;

  &.muted-user {
    background-image: url(${muteIcon});
  }

  &.dimmed {
    opacity: 0.3;
  }
`

export const CameraOffTile = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: #212121;

  display: none;

  &.camera-off-user {
    display: block;
    opacity: 1;
  }
`

export const CameraOffIcon = styled.div`
  background-image: url(${cameraOffIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  position: absolute;
  width: 50px;
  height: 30px;
  top: calc(50% - 15px);
  left: calc(50% - 25px);
`

export const UserName = styled.div`
  position: absolute;
  bottom: 10px;
  left: 35px;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  z-index: 2;
  font-family: 'Nunito';

  &.host {
    font-size: 1.5rem;
  }
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 50%;

  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;

  background-color: #342152;
  height: 4px;

  position: relative;
`

export const ProgressBarValue = styled.div`
  height: 100%;
  width: ${(props) => (props.width ? props.width + '%' : 0)};
  z-index: 2;
  background: #a1ff68;
  border-radius: 4px;
`

export const ProgressBarTime = styled.div`
  position: relative;

  font-family: 'Nunito';
  color: white;
  font-size: 1.1rem;
  top: 1rem;
`

export const ProgressVolumeContainer = styled.div`
  box-sizing: border-box;
  padding: 2px 5px;
  margin-top: 5px;
  width: 100%;
  /* height: 25px; */
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  display: flex;

  /* background: rgba(255, 255, 255, 0.2); */
  background-image: linear-gradient(
    to right,
    rgba(114, 143, 251, 0.4),
    rgba(232, 150, 177, 0.6) 98%
  );
  padding: 1.5% 5% 2% 5%;
  border-radius: 19px;
`

export const VolumeContainer = styled.div`
  width: 50%;
  height: 100%;
  margin-top: 3%;
  font-size: 3rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .MuiSvgIcon-root {
    width: 1.5em;
    height: 1.5em;
  }

  input {
    -webkit-appearance: none; /* Override default CSS styles */
    appearance: none;
    width: 100%; /* Full-width */
    height: 5px; /* Specified height */
    background: #a1ff68; /* Grey background */
    border-radius: 5px;
    outline: none; /* Remove outline */
    opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
    -webkit-transition: 0.2s; /* 0.2 seconds transition on hover */
    transition: opacity 0.2s;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 1.5vw; /* Set a specific slider handle width */
    height: 1.5vw; /* Slider handle height */
    border-radius: 50%;
    background: #342152; /* Green background */
    cursor: pointer; /* Cursor on hover */
  }

  .slider::-moz-range-thumb {
    width: 1.5vw; /* Set a specific slider handle width */
    height: 1.5vw; /* Slider handle height */
    border-radius: 50%;
    background: #342152; /* Green background */
    cursor: pointer; /* Cursor on hover */
  }
`

export const SelectedTrainingContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 8px;
  background-color: #202020;
  width: 105%;
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.25),
    0 22.3px 17.9px rgba(0, 0, 0, 0.42), 0 41.8px 33.4px rgba(0, 0, 0, 0.25),
    0 100px 80px rgba(0, 0, 0, 0.07);
`

export const QueueInfoBanner = styled.div`
  width: 30vw;

  bottom: 22.5vh;
  position: fixed;

  box-sizing: border-box;
  padding: 30px;
  z-index: 20;
  left: 35vw;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: center;
  font-size: 2.5rem;

  box-shadow: 0 1px 0.9px rgba(0, 0, 0, 0.011),
    0 2.5px 2.1px rgba(0, 0, 0, 0.016), 0 4.6px 4px rgba(0, 0, 0, 0.02),
    0 8.3px 7.1px rgba(0, 0, 0, 0.024), 0 15.5px 13.4px rgba(0, 0, 0, 0.029),
    0 37px 32px rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.3);

  display: flex;
  flex-direction: column;

  background-image: linear-gradient(
    to right,
    rgba(114, 143, 251, 0.7),
    rgba(232, 150, 177, 0.7) 98%
  );

  &.alternative {
    top: 13vh;
    bottom: unset;
  }

  &.error {
    max-width: 60%;
    left: 20%;
  }

  &.unallowed-redirect {
    width: 90%;
    position: relative;
    top: unset;
    bottom: unset;
    left: unset;
    font-family: 'Asap Condensed';
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
      0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
      0 100px 80px rgba(0, 0, 0, 0.07);
  }
`

export const QueueBannerHeader = styled.div`
  color: white;
  font-weight: bold;
  font-size: 2.5rem;
  margin-bottom: 20px;
`

export const QueueBannerRow = styled.div`
  margin: 5px 0;
`
export const QueueBannerInfoText = styled.span`
  font-size: 1.5rem;
  font-weight: normal;
  margin-right: 10px;
  opacity: 0.9;
  color: #c4fd03;

  &.big-size {
    font-size: 2.5rem;
  }

  &.alternative {
    margin-top: 5px;
  }

  &.color-white {
    color: white;
  }

  &.smaller-font {
    font-size: 1.3rem;
  }

  &.margin-bottom {
    margin-bottom: 10px;
  }
`
export const QueueBannerInfoValue = styled.span`
  font-size: 1.8rem;
  font-weight: bold;
  color: #c4fd03;

  &.alternative {
    margin-bottom: 20px;
    font-size: 2.5rem;
  }

  &.margin-bottom {
    margin-bottom: 20px;
  }
  &.color-white {
    color: white;
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
`

export const UnallowedRedirectContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    0deg,
    rgb(52, 33, 82) 0%,
    rgb(52, 33, 82) 37%,
    rgba(120, 23, 154, 0.973) 69%,
    rgb(52, 33, 82) 92%,
    rgb(52, 33, 82) 100%
  );
`

export const ErrorTextArea = styled.textarea`
  width: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  margin-top: 20px;
  font-size: 1rem;
  padding: 10px;
  min-height: 150px;

  &::placeholder {
    color: grey;
    font-size: 0.8em;
  }
`
export const VideoTile = styled.div`
  border-radius: 30px;
  background-image: linear-gradient(to right, #718ffc, #ea96b0);
  width: 96%;
  height: 12vh;
  display: flex;
  cursor: pointer;

  &.not-carousel-item {
    width: calc(95% - 25px);
  }

  &.inactive {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const Divider = styled.div`
  height: 1px;
  opacity: 0.5;
  background-color: #fff;
  width: 100%;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
`
